// place.state.ts
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { ItemPlace } from 'src/app/site/shared-components/item-location-overlay/models/model';
import { AddPlace, GetPlace } from './place.action';


export interface PlaceStateModel {
  place: ItemPlace | null;
}

@State<PlaceStateModel>({
  name: 'place',
  defaults: {
    place: null,
  },
})
export class PlaceState {
  @Selector()
  static getPlace(state: PlaceStateModel): ItemPlace | null {
    return state.place;
  }

  @Action(AddPlace)
  addPlace(ctx: StateContext<PlaceStateModel>, action: AddPlace) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      place: action.payload,
    });
  }

  @Action(GetPlace)
  getPlace(ctx: StateContext<PlaceStateModel>) {
    return ctx.getState().place;
  }
}
